import './styles.css';

import { useEffect, useRef, useState } from 'react';

interface IOnboarding {
  images: any;
  title: any;
  contents: {
    title: string;
    urlVIdeo: string;
  };
}
export function Onboarding({ contents, images, title }: IOnboarding) {
  const [isChecked, setIsChecked] = useState<boolean>();
  const [indexSlide, setIndexSlide] = useState(0);
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const checked = localStorage.getItem('onboardingClientCheck');
    checked && checked === 'true' ? setIsChecked(true) : setIsChecked(false);
  }, []);

  const isUrl = (url: string) => {
    if (url) {
      const res = url.match(
        /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_.~#?&//=]*)/g
      );
      return res !== null;
    }
  };

  const handleNext = () => {
    if (indexSlide !== Object.values(contents).length - 1) {
      setIndexSlide(indexSlide + 1);
    } else {
      handleFinish();
    }
  };

  const handleFinish = () => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }

    setIsChecked(true);
    localStorage.setItem('onboardingClientCheck', 'true');
  };

  return (
    <>
      {!isChecked ? (
        <div className="ob-box">
          <div className="ob-card">
            {Object.values(contents) &&
            isUrl(Object.values(contents)[indexSlide]) ? (
              <div className="ob-card-header video">
                <video
                  ref={videoRef}
                  className="ob-responsive-video"
                  preload="true"
                  controls
                  autoPlay
                  src={
                    Object.values(contents)[indexSlide] ||
                    Object.values(contents)[Object.values(contents).length - 1]
                  }
                ></video>
              </div>
            ) : (
              <>
                <div className="ob-card-header">
                  <img
                    src={images[indexSlide] || images[images.length - 1]}
                    alt=""
                  />
                </div>
                <div className="ob-card-content center">
                  <h2 className="ob-title">{title}</h2>
                  <p className="ob-content">
                    {(Object.values(contents) &&
                      Object.values(contents)[indexSlide]) ||
                      (Object.values(contents) &&
                        Object.values(contents)[
                          Object.values(contents).length - 1
                        ])}
                  </p>
                </div>
              </>
            )}
            <div className="ob-card-action center">
              <button className="ob-btn" onClick={() => handleFinish()}>
                Pular
              </button>
              <button className="ob-btn cta" onClick={() => handleNext()}>
                {Object.values(contents) &&
                indexSlide === Object.values(contents).length - 1
                  ? 'Finalizar'
                  : 'Próximo'}
              </button>
            </div>
            <div className="ob-card-footer center">
              {Object.values(contents) &&
                Object.values(contents).map((value: any, index: number) => (
                  <div
                    key={index}
                    className={
                      indexSlide === index ? 'ob-dot active' : 'ob-dot'
                    }
                  ></div>
                ))}
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
